<div class="mt-2">
  <div class="row">
    <div class="col-md-10 mt-4 w-100">
      <h4 class="title"> <i class="fa fa-suitcase" aria-hidden="true"></i> {{"NAV-BAR.ROLES"| translate}}</h4>
    </div>
    <div class="col-md-2 mt-4 content-position-end">
      <button type="button"
              class="btn btn-outline-success font-weight-bold mw-180 custom-button"
              *ngIf="hasAuthority('own:role:add')"
              (click)="openAddModal()">
        <i class="fa fa-plus"></i> {{ "BUTTON.ADD" | translate }}
      </button>
    </div>
  </div>
</div>
<div>
  <div class="table-responsive mt-2 mb-2 custom-table-height">
    <table class="table-sm table-bordered">
      <thead>
      <tr>
        <th scope="col" title="#"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.ABBREVIATION' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.NAME' | translate }}"></th>
        <th title="{{ 'TABLE.HEADER.DESCRIPTION' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.DATE' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.STATE' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.ACTION' | translate }}"></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let role of roles; let index=index">
        <td title="#" >{{(page.number * pageNumber) + index + 1}}</td>
        <td title="{{ 'TABLE.HEADER.ABBREVIATION' | translate }}">{{role.abbreviation}}</td>
        <td title="{{ 'TABLE.HEADER.NAME' | translate }}">{{role.name}}</td>
        <td title="{{ 'TABLE.HEADER.DESCRIPTION' | translate }}" class="custom-width-col">{{role.description}}</td>
        <td title="{{ 'TABLE.HEADER.DATE' | translate }}"> {{role.createAt | dateformat}}</td>
        <td title="{{ 'TABLE.HEADER.STATE' | translate }}">
          <span class="{{!role.active? 'badge badge-danger':''}}">
            {{role.active ? ('LABEL.ACTIVE' | translate) : ('LABEL.INACTIVE' | translate)}}
          </span>
        </td>
        <td title="{{ 'TABLE.HEADER.ACTION' | translate }}">
          <div class="dropdown">
            <button type="button"
                    class="btn btn-default "
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false">
              <i class="fa fa-ellipsis-v"></i>
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <button class="dropdown-item poniter"
                      *ngIf="hasEditableOption(role) && hasAuthority('own:role:edit')"
                      (click)="openModalEdit(role)">
                <i class="fa fa-pen"></i> {{ "BUTTON.EDIT" | translate }}
              </button>
              <button class="dropdown-item poniter"
                      *ngIf="hasAuthority('own:role:edit:authority')"
                      (click)="openModalAssignAuthority(role)">
                <i class="fa fa-plus"></i> {{ "BUTTON.ESTABLISH-PERMISSIONS" | translate }}
              </button>
              <button class="dropdown-item pointer"
                      *ngIf="hasEditableOption(role) && hasAuthority('own:role:delete')"
                      (click)="openModalDelete(role)">
                <i class="fa fa-trash"></i> {{ "BUTTON.DELETE" | translate }}
              </button>
            </div>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <nav class="Page navigation pagination-custom">
    <div class="row">
      <div class="col-md-8 mt-1">
        <div class="justify-content-row">
          <span class="mr-1 font-weight-normal">Mostrar </span>
          <select class="mr-1 br-6 form-control-sm" [(ngModel)]="pageNumber"
                  (ngModelChange)="loadRoles(enumPage.First)">
            <option *ngFor="let page of pageNumbers" [value]="page.value"
                    class="font-weight-bold">{{page.value}}</option>
          </select>
          <span class="font-weight-normal"> registros.</span>
        </div>
        <div class="page-total-entries">
          {{ "LABEL.TOTAL-RECORDS" | translate }}
          : {{roles.length + (page.number * page.size)}} {{ "LABEL.OF" | translate }} {{page.totalElements}}
        </div>
      </div>
      <div class="col-md-4">
        <ul class="pagination justify-content-end text-center">
          <li class="page-item btn-paged-ends cursor-pointer {{page.number === 0 ? 'disabled' : ''}}">
            <a class="prev {{page.number === 0 ? 'disabled' : ''}}" (click)="loadRoles(enumPage.First)"
               tabindex="-1" aria-disabled="true">
              <i class=" fa fa-angle-double-left" aria-hidden="true"></i>
              {{ "BUTTON.FIRST" | translate }}
            </a>
          </li>
          <li class="cursor-pointer {{page.number == 0 ? 'disabled' : ''}}">
            <a class="left" (click)="loadRoles(enumPage.Previous)">
              <i class="fa fa-angle-left" aria-hidden="true"></i></a>
          </li>
          <li class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}">
            <a class="right" (click)="loadRoles(enumPage.Next)"><i
              class="fa fa-angle-right" aria-hidden="true"></i></a>
          </li>
          <li class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}"
              (click)="loadRoles(enumPage.Last)">
            <a class="next">
              {{ "BUTTON.LAST" | translate }}
              <i class="fa fa-angle-double-right" aria-hidden="true"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</div>
<app-loading *ngIf="loading"></app-loading>
